import * as React from 'react';
import { useTranslation } from 'react-i18next';

import './style.scss';

const CompaniesResult = ({ title, cocNumber, regulation }) => {
  const { t } = useTranslation();
  return (
    <article
      className="CompaniesResult row"
    >
      <div className="CompaniesResult__title col-12 col-md-6">
        <div className="label">{t('search.companies.result_header_title')}</div>
        {title}
      </div>
      <div className="CompaniesResult__coc  col-6 col-md-3">
        <div className="label">{t('search.companies.result_header_coc')}</div>
        {cocNumber}
      </div>
      <div className="CompaniesResult__regulation col-6 col-md-3">
        <div className="label">{t('search.companies.result_header_regulation')}</div>
        {regulation}
      </div>
    </article>
  );
};

export default CompaniesResult;
